/* Happymami · PDP — movimiento: aparición al hacer scroll, ondas al pulsar, parallax suave de las burbujas
   y rebote del botón al cambiar de pack. Sin librerías. Respeta «Reducir movimiento» y no esconde nada en el editor. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = !!(window.Shopify && window.Shopify.designMode);
  var small = window.matchMedia && window.matchMedia('(max-width: 899.98px)').matches;
  var parallax = [];
  var ticking = false;

  // Un bloque se anima por grupos: el primer elemento (líder) decide cuándo entra el grupo y sus seguidores entran con él, con
  // retardo escalonado. Así nada que ya se ve en pantalla se queda oculto esperando (huecos en blanco). Cada elemento sale solo.
  function reveal(el, kind, delay, leader) {
    if (!el || el.classList.contains('hm-rv')) return;
    el.classList.add('hm-rv');
    if (kind) el.classList.add('hm-rv--' + kind);
    if (delay) el.style.setProperty('--hm-d', delay + 'ms');
    watch(el);
  }
  // Cada bloque entra al aparecer en pantalla y sale al desaparecer (por arriba o por abajo), cada vez que se hace scroll.
  // Blindado contra el parpadeo en el borde: la entrada y la salida usan franjas distintas (histéresis: se entra en la franja
  // central y solo se sale al abandonar otra más ancha, mayor que lo que se mueve el propio bloque al animarse) y, además,
  // un bloque no puede cambiar de estado dos veces en menos de 400 ms.
  var enterIO = null;
  var exitIO = null;
  var HOLD = 400;
  function setState(el, inside, up) {
    var now = Date.now();
    if (el.__hmT && now - el.__hmT < HOLD) return;
    if (inside) {
      if (el.classList.contains('is-in')) return;
      el.__hmT = now;
      el.classList.remove('is-up', 'is-down');
      el.classList.add('is-in');
    } else {
      if (!el.classList.contains('is-in')) return;
      el.__hmT = now;
      el.classList.remove('is-in');
      el.classList.toggle('is-up', up);
      el.classList.toggle('is-down', !up);
    }
  }
  function watch(el, exitOnly) {
    if (!enterIO) {
      // Entrada: el bloque se anima en cuanto asoma por abajo (banda 6 %-90 % de la pantalla), así se ve subir mientras entra y no queda hueco.
      enterIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && (small || entry.intersectionRatio >= 0.1)) {
              setState(entry.target, true);
              (entry.target.__fol || []).forEach(function (f) { setState(f, true); });
            }
          });
        },
        { threshold: [0, 0.1], rootMargin: small ? '-6% 0px -10% 0px' : '0px 0px -8% 0px' }
      );
      // Salida: solo al quedar fuera de una franja bastante más ancha que la de entrada.
      exitIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) setState(entry.target, false, entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0, rootMargin: small ? '0% 0px -2% 0px' : '4% 0px 4% 0px' }
      );
    }
    if (!exitOnly) enterIO.observe(el);
    exitIO.observe(el);
  }
  // list[0] es el líder del grupo (o `leader` si se indica); el resto entra con él.
  function stagger(list, kind, step, leader) {
    var arr = Array.prototype.slice.call(list);
    var lead = leader || arr[0];
    arr.forEach(function (el, i) { reveal(el, kind, i * (step || 90), lead); });
  }
  // Red de seguridad: lo que ya se ve en pantalla y sigue oculto aparece. Con scroll rápido se hace mientras se mueve (no al
  // parar) y con una entrada corta, para no ver la pantalla vacía; con scroll normal, 0,3 s después de parar.
  var sweepTimer = 0;
  function sweepRun(root, fast) {
    var vh = window.innerHeight || 800;
    root.querySelectorAll('.hm-rv:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (!r.height) return;
      var seen = Math.min(r.bottom, vh) - Math.max(r.top, 0);
      if (seen > r.height * (fast ? 0.15 : 0.35) && r.top < vh * 0.97) {
        if (fast) {
          el.classList.add('hm-rv--fast');
          setTimeout(function () { el.classList.remove('hm-rv--fast'); }, 600);
        }
        setState(el, true);
      }
    });
  }
  function sweep(root) {
    clearTimeout(sweepTimer);
    sweepTimer = setTimeout(function () { sweepRun(root, false); }, 320);
  }

  function initReveal(root) {
    var q = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    // 1 · Pensado para ti y para tu bebé
    stagger(q('.inside .center > *'), '', 80);
    q('.inside .card').forEach(function (card) {
      reveal(card, 's');
      stagger(card.querySelectorAll('.ci'), 'l', 70, card);
    });
    // 2 · Una tetina que se parece a ti: la foto lidera el título, el texto y las pestañas
    var teatImg = q('.teat-img')[0];
    if (teatImg) {
      reveal(teatImg, 'l');
      stagger(q('.teat .stack > *').concat(q('#hm-teat-items')), '', 100, teatImg);
    }
    // 3 · Mucho más que un biberón
    var boxImg = q('.box-img')[0];
    if (boxImg) {
      reveal(boxImg, 'l');
      stagger(q('.box .stack > *').concat(q('.box .table-wrap')), '', 100, boxImg);
    }
    // 4 · Tus primeras tomas: textos, pasos y botón entran juntos; el móvil de Clara aparte
    stagger(q('.first .stack > .stack > *').concat(q('.tl-i'), q('.first .cta')), '', 90);
    stagger(q('.astage'), 's', 80);
    // ondas
    q('.wv').forEach(function (w) { watch(w); });
    var lastY = window.pageYOffset;
    var lastT = performance.now();
    var lastFast = 0;
    window.addEventListener('scroll', function () {
      var now = performance.now();
      var y = window.pageYOffset;
      var speed = Math.abs(y - lastY) / Math.max(1, now - lastT); // px por ms
      lastY = y;
      lastT = now;
      if (speed > 0.9 && now - lastFast > 60) { lastFast = now; sweepRun(root, true); }
      sweep(root);
    }, { passive: true });
    sweep(root);
  }

  function initRipple(root) {
    root.addEventListener('pointerdown', function (e) {
      var t = e.target.closest ? e.target.closest('.cta, .ptable thead button, .item-btn') : null;
      if (!t || !root.contains(t)) return;
      var r = t.getBoundingClientRect();
      var dot = document.createElement('span');
      dot.className = 'hm-ripple';
      dot.style.left = e.clientX - r.left + 'px';
      dot.style.top = e.clientY - r.top + 'px';
      t.appendChild(dot);
      setTimeout(function () { dot.remove(); }, 750);
    });
  }

  function initCtaSwap(root) {
    var cta = root.querySelector('#hm-pack-cta');
    if (!cta || cta.__hmSwap) return;
    cta.__hmSwap = true;
    new MutationObserver(function () {
      cta.classList.remove('hm-swap');
      void cta.offsetWidth;
      cta.classList.add('hm-swap');
    }).observe(cta, { childList: true, characterData: true, subtree: true });
  }

  function initParallax(root) {
    parallax = Array.prototype.slice.call(root.querySelectorAll('.blob, .ill'));
    if (!parallax.length) return;
    update();
  }
  function update() {
    ticking = false;
    var vh = window.innerHeight || 800;
    parallax.forEach(function (el, i) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var offset = (r.top + r.height / 2 - vh / 2) / vh;
      var speed = (i % 2 ? -1 : 1) * 26;
      el.style.translate = '0 ' + (offset * speed).toFixed(1) + 'px';
    });
  }
  window.addEventListener('scroll', function () {
    if (!parallax.length || ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }, { passive: true });

  // Biberón abriéndose, ligado al scroll: secuencia de imágenes dibujada en un canvas (sin saltos, a diferencia de mover un vídeo).
  // Al subir la sección se abre (anilla, tetina y tapón), se mantiene abierto en el centro y se cierra al salir. Los textos de las
  // piezas siguen el segundo de la animación.
  function initFrames(root) {
    var canvas = root.querySelector('.vban-canvas');
    var dataEl = root.querySelector('script[data-hm-bib]');
    if (!canvas || !dataEl || canvas.__hm) return;
    canvas.__hm = true;
    var urls = [];
    try { urls = JSON.parse(dataEl.textContent); } catch (e) {}
    if (!urls.length) return;
    var FPS = parseFloat(canvas.getAttribute('data-fps')) || 15;
    var N = urls.length;
    var TOTAL = (N - 1) / FPS;
    var OPEN = 4.8; // segundo con todo separado
    var ctx = canvas.getContext('2d');
    var frames = new Array(N);
    var labels = Array.prototype.slice.call(root.querySelectorAll('.vl'));
    var started = false;
    var current = 0;
    var running = false;
    var drawn = -1;

    function draw(i) {
      var k = i;
      while (k >= 0 && !frames[k]) k--;
      if (k < 0) { k = i; while (k < N && !frames[k]) k++; }
      if (k < 0 || k >= N || !frames[k] || k === drawn) return;
      ctx.drawImage(frames[k], 0, 0, canvas.width, canvas.height);
      drawn = k;
    }
    function sync(t) {
      labels.forEach(function (l) {
        var on = t >= parseFloat(l.getAttribute('data-from')) && t <= parseFloat(l.getAttribute('data-to'));
        if (l.classList.contains('is-on') !== on) l.classList.toggle('is-on', on);
      });
    }
    function loadOne(i, done) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { frames[i] = img; if (i === 0) draw(0); done(); };
      img.onerror = done;
      img.src = urls[i];
    }
    function load() {
      if (started) return;
      started = true;
      var next = 0;
      var order = [];
      // primero el cuadro 0 y los cuadros "clave" (cada 10), después el resto
      for (var a = 0; a < N; a += 10) order.push(a);
      for (var b = 0; b < N; b++) if (b % 10) order.push(b);
      function pump() {
        if (next >= order.length) return;
        loadOne(order[next++], function () { pump(); kick(); });
      }
      for (var c = 0; c < 6; c++) pump();
    }
    function progress() {
      var r = canvas.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var start = vh * 0.92;
      var end = -r.height * 0.35;
      return Math.max(0, Math.min(1, (start - r.top) / (start - end)));
    }
    function timeFor(p) {
      if (p < 0.5) return (p / 0.5) * OPEN;
      if (p < 0.72) return OPEN;
      return OPEN + ((p - 0.72) / 0.28) * (TOTAL - OPEN);
    }
    function tick() {
      running = false;
      var target = timeFor(progress()) * FPS;
      var diff = target - current;
      if (Math.abs(diff) > 0.05) { current += diff * 0.2; running = true; } else { current = target; }
      draw(Math.round(current));
      sync(current / FPS);
      if (running) requestAnimationFrame(tick);
    }
    function kick() { if (!running) { running = true; requestAnimationFrame(tick); } }

    if (reduced) {
      load();
      frames[0] = null;
      var fixed = Math.round(OPEN * FPS);
      var im = new Image();
      im.onload = function () { frames[fixed] = im; draw(fixed); };
      im.src = urls[fixed];
      labels.forEach(function (l) { l.classList.add('is-on'); });
      return;
    }
    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
    if (!('IntersectionObserver' in window)) { load(); kick(); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { load(); kick(); } });
    }, { rootMargin: '800px 0px 800px 0px', threshold: 0 }).observe(canvas);
  }

  function init() {
    var root = document.querySelector('.hm-pdp');
    if (!root) return;
    initFrames(root);
    initRipple(root);
    initCtaSwap(root);
    if (reduced) return;
    if (!editor) {
      document.documentElement.classList.add('hm-pdp-js');
      initReveal(root);
    }
    initParallax(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { document.querySelectorAll('.hm-pdp .hm-rv').forEach(function (el) { el.classList.add('is-in'); }); });
})();
